import jsPDF from 'jspdf';
import { TestResults } from '../../../../types';
import { PDF_COLORS } from '../../config/colors';
import { PDF_FONTS, PDF_LAYOUT } from '../../config/fonts';
import { PageManager } from '../../helpers/pageBreaks';
import { CategoryRecommendationsComponent } from './CategoryRecommendations';

export class PriorityRecommendationsComponent {
  private pdf: jsPDF;
  private pageManager: PageManager;
  private categoryRecommendations: CategoryRecommendationsComponent;

  constructor(pdf: jsPDF, pageManager: PageManager) {
    this.pdf = pdf;
    this.pageManager = pageManager;
    this.categoryRecommendations = new CategoryRecommendationsComponent(pdf, pageManager);
  }

  render(results: TestResults): void {
    this.renderSectionHeader();
    this.renderPriorityCategories(results);
  }

  private renderSectionHeader(): void {
    this.pageManager.checkForPageBreak(50, {
      minSpaceAfter: 40,
      elementType: 'priority-section-header',
    });

    this.pdf.setFont(PDF_FONTS.primary, 'bold');
    this.pdf.setFontSize(PDF_FONTS.size.subheading);
    this.pdf.setTextColor(...PDF_COLORS.primary);
    this.pdf.text(
      'Priority Improvement Areas',
      PDF_LAYOUT.margins.left,
      this.pageManager.getCurrentY()
    );

    this.pageManager.addElement(PDF_FONTS.size.subheading, {
      spacingAfter: PDF_LAYOUT.spacing.paragraph,
      elementType: 'priority-header',
    });
  }

  private renderPriorityCategories(results: TestResults): void {
    const weakestCategories = [...results.categories]
      .sort((a, b) => a.percentage - b.percentage)
      .slice(0, 3);

    weakestCategories.forEach((category, index) => {
      this.categoryRecommendations.render(category, index + 1);
    });
  }
}